<p-sidebar id="mobileAppNavSideBar" [(visible)]="turnOnMobileAppNavigation" [modal]=false [blockScroll]=true [showCloseIcon]=false (onShow)="onMobileAppNavShow()" (onHide)="onMobileAppNavHide()">
    <app-navigation [is-large-screen]="false"></app-navigation>
</p-sidebar>